import React, { useState } from "react";
import { apiDocs } from "@/content/site";
import { PageHero, CtaBand } from "@/components/NovaKit";

export default function ApiDocs() {
  const [active, setActive] = useState(0);
  const current = apiDocs.sections[active];

  return (
    <div data-testid="apidocs-page">
      <PageHero
        eyebrow={apiDocs.eyebrow}
        heading={apiDocs.heading}
        highlight="Future-facing"
        intro={apiDocs.intro}
        index="09"
      />

      <section className="border-t hairline">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-3" data-testid="api-sidebar">
            <div className="mono text-[10px] tracking-[0.25em] uppercase text-[#0A0E1A]/55 mb-5">
              Sections
            </div>

            <nav className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible">
              {apiDocs.sections.map(([name], i) => (
                <button
                  key={name}
                  onClick={() => setActive(i)}
                  className={
                    "text-left mono text-[11px] tracking-[0.1em] uppercase whitespace-nowrap px-3 py-2.5 rounded-lg transition-colors " +
                    (i === active
                      ? "grad-bg text-white font-semibold"
                      : "text-[#0A0E1A]/70 hover:bg-[#F5F6FA]")
                  }
                  data-testid={`api-section-${i}`}
                >
                  <span className="opacity-70 mr-2">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {name}
                </button>
              ))}
            </nav>
          </aside>

          <div className="lg:col-span-9">
            <div className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mb-4">
              09.{String(active + 1).padStart(2, "0")}
            </div>

            <h2 className="display text-3xl md:text-5xl font-bold tracking-tight mb-6">
              {current[0]}
            </h2>

            <p className="text-base md:text-lg text-[#0A0E1A]/75 leading-relaxed max-w-3xl mb-10">
              {current[1]}
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              <a
                href="/docs/hubinall-bank-api.docx"
                download
                className="inline-flex items-center rounded-full grad-bg text-white px-5 py-3 text-sm font-semibold shadow-[0_8px_24px_-8px_rgba(79,70,229,0.5)] hover:opacity-90 transition-opacity"
              >
                Download API Documentation
              </a>

              <a
                href="/docs/hubinall-bank-api.docx"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center rounded-full border hairline px-5 py-3 text-sm font-semibold hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors"
              >
                Open Document
              </a>
            </div>

            <div className="rounded-[20px] overflow-hidden border hairline bg-[#0A0E1A] text-white mono text-[12px] leading-relaxed">
              <div className="flex items-center justify-between border-b border-white/10 px-5 py-3">
                <span className="grad-text font-semibold">
                  /api/hubinall/{active.toString(16).padStart(2, "0")}
                </span>
                <span className="text-white/50">GET</span>
              </div>

              <pre className="px-5 py-5 whitespace-pre-wrap text-white/90">
{`{
  "layer": "${current[0]}",
  "status": "directional",
  "description": "${current[1].slice(0, 180).replace(/"/g, "'")}..."
}`}
              </pre>
            </div>

            <div className="mt-12 panel rounded-2xl p-6 border hairline">
              <div className="mono text-[10px] tracking-[0.25em] uppercase grad-text font-bold mb-3">
                Disclaimer
              </div>
              <p className="text-sm md:text-base text-[#0A0E1A]/75 leading-relaxed">
                {apiDocs.disclaimer}
              </p>
            </div>
          </div>
        </div>
      </section>

      <CtaBand
        heading="Let's discuss integration architecture."
        ctas={apiDocs.ctas}
      />
    </div>
  );
}